<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { getRequest } from '@/Util/utils';

  // The report as a PDF file, made on the server from this page and saved by the browser.
  export let planId: string;
  export let forUser: string | null = null;

  // The report can be rebuilt from the athlete's history as it is now.
  export let canRebuild = true;

  const dispatch = createEventDispatcher();
  let busy = false;
  let failed = false;
  let rebuilding = false;
  let rebuildFailed = false;
  let rebuildMessage = '';
  let rebuilt = false;

  async function rebuild() {
    rebuilding = true;
    rebuildFailed = false;
    rebuilt = false;
    try {
      const response = await window.fetch(`/plan-report/${encodeURIComponent(planId)}/rebuild${forUser ? `?forUser=${encodeURIComponent(forUser)}` : ''}`, { method: 'POST', ...getRequest(), body: JSON.stringify({}) });
      const result = await response.json();
      if (!response.ok || !result.result) throw new Error(result.message ?? '');
      dispatch('rebuilt');
      rebuilt = true;
      setTimeout(() => (rebuilt = false), 4000);
    } catch (e) {
      rebuildFailed = true;
      rebuildMessage = e instanceof Error ? e.message : '';
    } finally {
      rebuilding = false;
    }
  }

  async function download() {
    busy = true;
    failed = false;
    try {
      const query = forUser ? `?forUser=${encodeURIComponent(forUser)}` : '';
      const response = await window.fetch(`/plan-report/${encodeURIComponent(planId)}/pdf${query}`, { credentials: 'same-origin', headers: { Accept: 'application/pdf' } });
      if (!response.ok) throw new Error('PDF failed');
      const blob = await response.blob();
      const name = /filename="?([^";]+)"?/.exec(response.headers.get('Content-Disposition') ?? '')?.[1] ?? 'Xert-plan-report.pdf';
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = name;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(link.href), 10000);
    } catch (e) {
      failed = true;
    } finally {
      busy = false;
    }
  }
</script>

<div class="print:hidden flex flex-col items-start sm:items-end gap-1">
  <div class="flex items-center gap-2">
  {#if canRebuild}
    <button class="rounded border border-zinc-300 bg-white px-3 py-1.5 text-sm hover:bg-zinc-50 disabled:opacity-60" on:click={rebuild} disabled={rebuilding || busy} title={$_('report.share.rebuild_title')}>{rebuilding ? $_('report.share.rebuilding') : $_('report.share.rebuild')}</button>
  {/if}
  <button class="rounded border border-zinc-300 bg-white px-3 py-1.5 text-sm hover:bg-zinc-50 disabled:opacity-60" on:click={download} disabled={busy}>{busy ? $_('report.share.preparing') : $_('report.share.download')}</button>
  </div>
  {#if rebuilt}<p class="text-xs text-green-700" role="status">{$_('report.share.rebuilt')}</p>{/if}
  {#if rebuildFailed}<p class="text-xs text-red-700" role="alert">{rebuildMessage || $_('report.share.rebuild_failed')}</p>{/if}
  {#if failed}<p class="text-xs text-red-700" role="alert">{$_('report.share.pdf_failed')}</p>{/if}
</div>
